<template>
  <div>
    <base-header v-if="0" class="pb-6  bg-gradient-info">
    
    
 
      
      
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--6">
     <div class="row justify-content-center">
      	  <div class="" style="padding-left:10px;padding-right:10px;">
      	    <div style="min-height:140px;"></div>
      		<!-- Form controls -->
            <div class="card">
              <!-- Card header -->
              <div class="card-header bg-gradient-default">
              	<div v-if="rtype==1">
                		<h2 class="heading mb-0 text-white">Appointment Of New Director</h2>  		
                </div>
                <div v-if="rtype==2">
                		<h2 class="heading mb-0 text-white">Resignation Of New Director</h2>  		
                </div>
                <div v-if="rtype==3">
                		<h2 class="heading mb-0 text-white">Allotment OF New Shares</h2>  		
                </div>
                <div v-if="rtype==4">
                		<h2 class="heading mb-0 text-white">Share Transfer</h2>  		
                </div>
                <div v-if="rtype==5">
                		<h2 class="heading mb-0 text-white">Change Company Address</h2>  		
                </div>
                <div v-if="rtype==6">
                		<h2 class="heading mb-0 text-white">Change Company Name</h2>  		
                </div>
                <div v-if="rtype==7">
                		<h2 class="heading mb-0 text-white">Opening Of New Bank Account</h2>  		
                </div>
                <div v-if="rtype==8">
                		<h2 class="heading mb-0 text-white">Schedule Annual General Meeting (AGM)</h2>  		
                </div>
                <div v-if="rtype==901">
                		<h2 class="heading mb-0 text-white">Custom Request</h2>  		
                </div>
              </div>
              <!-- Card body -->
              <div class="card-body">
              
              <div class="" style="font-size:15px;margin-top:20px;margin-bottom:60px;">
                		<div style="margin-top:10px;margin-bottom:20px;">
                			<p style="font-size:15px;">To process this request, please provide us the following information:</p>
                		</div>
                		
                		<ul>
                			<div v-if="rtype==1">
                				<li style="font-size:13px;">Particulars of new director including address, nationality, NRIC, email address and contact number.</li>
                				<li style="font-size:13px;">Date on which director is appointed.</li>
                				<li style="font-size:13px;">Please note that you might be required to upload supporting documents after submitting this request.</li>
                			</div>
                			
                			<div v-if="rtype==2">
                				<li style="font-size:13px;">Name and NRIC/FIN of director to remove</li>
                				<li style="font-size:13px;">Date of resignation for director to be removed.</li>
                			</div>
                			
                			
                			<div v-if="rtype==3">
                				<li style="font-size:13px;">Particulars of new shareholder including address, nationality, NRIC, email address and contact number.</li>
                				<li style="font-size:13px;">How many new shares are being issued and the date on which they are issued.</li>
                				<li style="font-size:13px;">Please note that you might be required to upload supporting documents after submitting this request.</li>
                			</div>
                			
                			
                			<div v-if="rtype==4">
                				<li style="font-size:13px;">Name and NRIC/FIN of the shareholder transferring the shares and the person receiving the shares.</li>
                				<li style="font-size:13px;">If the person receiving the shares is not an existing shareholder of the company, please also provide his/her 
                				particulars including name, address, nationality, NRIC, email address and contact number.</li>
                				<li style="font-size:13px;">The number of shares being transferred and the date on which they are transferred.</li>
                				<li style="font-size:13px;">Please note that you might be required to upload supporting documents after submitting this request.</li>
                			</div>
                			
                			
                			<div v-if="rtype==5">
                				<li style="font-size:13px;">The new company address.</li>
                				<li style="font-size:13px;">Effective date of new company address.</li>
                				<li style="font-size:13px;">Please note that you might be required to upload supporting documents after submitting this request.</li>
                			</div>
                			
                			
							<div v-if="rtype==6">
                				<li style="font-size:13px;">The new company name.</li>
                				<li style="font-size:13px;">Effective date of new company name.</li>
                			</div>
                			
                			
                			<div v-if="rtype==8">
                				<li style="font-size:13px;">Preferred date of AGM</li>
                				<li style="font-size:13px;">Agenda for the AGM apart from presenting the company's financial statements.</li>
                				<li style="font-size:13px;">$60 is the amount paid to ACRA for filing the Annual Return.</li>
                			</div>
                			
                			
                			<div v-if="rtype==901">
                				<li style="font-size:13px;">Tell us about your request!</li>
                			</div>
                			
                			
                		</ul>
                		
                		
                		
                		
                		<div style="padding:20px 0px 10px 20px">
							<div v-if="rtype==1">
								<base-button outline type="warning">Price: $150 </base-button>
							 </div>
							 <div v-if="rtype==2">
								<base-button outline type="warning">Price: $150 </base-button>
							 </div>
							 <div v-if="rtype==3">
								<base-button outline type="warning">Price: $200 </base-button>
							 </div>
							 <div v-if="rtype==4">
								<base-button outline type="warning">Price: $150 per share transfer </base-button>
							 </div>
							 <div v-if="rtype==5">
								<base-button outline type="warning">Price: $150 </base-button>
							 </div>
							 <div v-if="rtype==6">
								<base-button outline type="warning">Price: $150 </base-button>
							 </div>
							 <div v-if="rtype==7">
								<base-button outline type="warning">Price: $150 </base-button>
							 </div>
							  <div v-if="rtype==8">
								<base-button outline type="warning">Price: $60 </base-button>
							 </div>
                		</div>
                		
                		
                		
                		
                </div>
                		
                		
                <form>
                  <base-input label="Please enter all required information below.">
                    <textarea class="form-control" v-model="model.description" rows="3"></textarea>
                  </base-input>
                </form>
                 <base-button block type="primary" @click.prevent="submitCreateRequest">Submit Request</base-button>
                  <div style="margin-top:20px;text-align:center;">
                  		<p class="text-muted" style="font-size:12px;"> 
                  		If you would like to attach a file, submit this request first.
                  		</p>
                  </div>
              </div>
             
            </div>
     
    

       	 </div>
      </div>
      <!-- End row-->

      <!--start new row-->
     




    
    </div>  <!--End container-->
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>

  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';

  export default {
    components: {
  
    },
    data() {
      return {
     	 officers:[],
     	 rtype: this.$route.params.type,
		 model:{
		 	type: this.$route.params.type,
		 	description:'',
		 	eid:'',
		 }	
      };
    },
    methods: {
      submitCreateRequest() {
      	if(!this.model.description){
      		swal.fire({
							title: `Oops`,
							text: "Please enter all required information before submitting.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
      	
      	}else{
      		swal.showLoading();
		  	let uri = this.$base_url+'/api/v1/c/create_request';
			 ApiService.post(uri, this.model).then(response => {
				swal.close();
				this.$router.push( '/view-request/'+response.data.rid);
  
			}) 
      	}//end if-else fields are filled in

      }
    },
    mounted() {
    	const client_info = JSON.parse(TokenService.getUserInfo());
    	this.model.eid = client_info.entity_id;
      
      	
      	
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














